import { doGet } from '../../helpers';
import { UserInformation } from '#/models/UserInformation';

export const userInformation = {
  me: () =>
    doGet<UserInformation>('/user-information/me')
};
